import { api } from "@/features/auth/api";
import type {
    Category,
    Product,
    ProductListResponse,
    ProductQuery,
} from "@/features/catalog/types";

/**
 * Catalog HTTP layer — thin wrappers around the shared axios client.
 * Consumed exclusively via the TanStack Query hooks in `./hooks`.
 */
export const catalogApi = {
    listCategories: async (): Promise<Category[]> => {
        const { data } = await api.get<Category[]>("/categories");
        return data;
    },

    getCategory: async (slug: string): Promise<Category> => {
        const { data } = await api.get<Category>(`/categories/${slug}`);
        return data;
    },

    listProducts: async (q: ProductQuery = {}): Promise<ProductListResponse> => {
        const params: Record<string, string | number> = {};
        if (q.category) params.category = q.category;
        if (q.search) params.search = q.search;
        if (q.tag) params.tag = q.tag;
        if (q.sort) params.sort = q.sort;
        if (q.page) params.page = q.page;
        if (q.page_size) params.page_size = q.page_size;
        const { data } = await api.get<ProductListResponse>("/products", { params });
        return data;
    },

    getProduct: async (idOrSlug: string): Promise<Product> => {
        const { data } = await api.get<Product>(`/products/${idOrSlug}`);
        return data;
    },
};
